<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="logo"
            width="100"
          />
        </b-link>

        <b-card-title class="mb-1">
        </b-card-title>

        <!-- form -->
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <b-form-group
              label="Jenis Pengguna"
              label-for="userTypes"
            >
              <validation-provider
                #default="{ errors }"
                name="userTypes"
                rules="required"
              >
                <v-select
                  id="userTypes"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="userTypes"
                  v-model="selectedUserType"
                  placeholder="Pilih Jenis Pengguna"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- username -->
            <b-form-group
              label="Nama Lengkap"
              label-for="name"
            >
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="name"
                  :state="errors.length > 0 ? false:null"
                  name="register-nama"
                  placeholder="Isi nama anda"
                />
                <small class="text-danger">{{ errors[0] ? 'Silahkan isi nama anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="NPM"
              label-for="npm"
              v-if="selectedUserType === 'Mahasiswa'"
            >
              <validation-provider
                #default="{ errors }"
                name="npm"
                rules="required"
              >
                <b-form-input
                  id="npm"
                  v-model="npm"
                  :state="errors.length > 0 ? false:null"
                  name="register-email"
                  placeholder="NPM"
                  type="number"
                />
                 <small class="text-danger">{{ errors[0] ? 'Silahkan isi npm anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="NIP"
              label-for="nip"
              v-if="selectedUserType === 'Dosen/Pembimbing'"
            >
              <validation-provider
                #default="{ errors }"
                name="nip"
                rules="required"
              >
                <b-form-input
                  id="nip"
                  v-model="nip"
                  :state="errors.length > 0 ? false : null"
                  name="register-email"
                  placeholder="NIP"
                  type="number"
                />
                  <small class="text-danger">{{ errors[0] ? 'Silahkan isi nip anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- email -->
            <b-form-group
              label="Email"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  :state="errors.length > 0 ? false:null"
                  name="register-email"
                  placeholder="alamat-email@ui.ac.id"
                />
                 <small class="text-danger">{{ errors[0] ? 'Silahkan isi email anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group
              label="Password"
              label-for="password"
            >
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    name="register-password"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="'EyeIcon'"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                 <small class="text-danger">{{ errors[0] ? 'Password minimal 6 karakter' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="register-privacy-policy"
                v-model="status"
                name="checkbox-1"
              >
                Saya menyetujui
                <b-link>Syarat & Ketentuan</b-link>
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              :disabled="status == false"
              variant="primary"
              block
              type="submit"
            >
              Daftar
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>Sudah memiliki akun? </span>
          <b-link :to="{name:'auth-login-v1'}">
            <span>login</span>
          </b-link>
        </b-card-text>

        <div class="divider my-2">
          <div class="divider-text">
            
          </div>
        </div>

        <!-- social buttons -->
        <!-- <div class="auth-footer-btn d-flex justify-content-center">
          <b-button
            variant="facebook"
            href="javascript:void(0)"
          >
            <feather-icon icon="FacebookIcon" />
          </b-button>
          <b-button
            variant="twitter"
            href="javascript:void(0)"
          >
            <feather-icon icon="TwitterIcon" />
          </b-button>
          <b-button
            variant="google"
            href="javascript:void(0)"
          >
            <feather-icon icon="MailIcon" />
          </b-button>
          <b-button
            variant="github"
            href="javascript:void(0)"
          >
            <feather-icon icon="GithubIcon" />
          </b-button>
        </div> -->
      </b-card>
    <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import vSelect from 'vue-select'
import store from '@/store/index'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  postRegister,
} from '@/connection-api/master'

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    vSelect,
    // validations
    ValidationProvider,
    ValidationObserver,
    BImg,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      regEmail: '',
      name: '',
      password: '',
      status: '',
      npm: null,
      selectedUserType: '',
      userTypes: ['Mahasiswa', 'Dosen/Pembimbing', 'Peneliti Eksternal'],
      // validation rules
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
    }
  },
  // validations: {
  //   selectedUserType: {
  //     required: required,
  //   },
  // },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          var data = {
            name: this.name,
            password: this.password,
            email: this.email,
            register_as: 'pengaju',
            jenis_pengguna: this.selectedUserType,
            npm: this.npm,
            nip: this.nip,
          }
          postRegister(data)
          .then(response => {
            if (response.data.success === true) {
               this.makeToast('success', 'Data berhasil didaftarkan.')
               setTimeout(() => {
                this.$router.push({name: 'auth-login'})
               }, 3000);
            } else {
               this.makeToast('danger', response.data.message)
            }
          })
          .catch(error => console.log(error));
        }
      })
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Register',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
